<template>
  <div class="ListingFavourite text-[1.9rem]">
    <template v-if="signedIn">
      <button
        data-gtm-trigger="add_to_favorites"
        :data-gtm-title="listing.title"
        v-show="!liked"
        @click.prevent="toggleLike"
        class="flex items-center"
      >
        <FaIcon :icon="['fal', 'heart']" class="text-gray-950 hover:text-primary active:text-primary" />
        <slot :liked="liked" :count="listing.favourites_count"></slot>
      </button>
      <button
        data-gtm-trigger="remove_from_favorites"
        :data-gtm-title="listing.title"
        v-show="liked"
        class="liked flex items-center"
        @click.prevent="toggleLike"
      >
        <FaIcon :icon="['fas', 'heart']" class="text-bt-blue-500" />
        <slot :liked="liked" :count="listing.favourites_count"></slot>
      </button>
    </template>

    <template v-else>
      <div
        v-for="stacking_context in stacking_contexts"
        :key="stacking_context"
        :class="{ 'hidden md:block': stacking_context === 'top', 'md:hidden': stacking_context === 'bottom' }"
      >
        <button
          data-gtm-trigger="remove_from_favorites"
          :data-gtm-title="listing.title"
          @click.prevent="toggleGuestFavourite(stacking_context)"
          v-show="liked"
          class="flex items-center"
        >
          <FaIcon :icon="['fas', 'heart']" class="text-bt-blue-500" />
          <slot :liked="liked" :count="listing.favourites_count"></slot>
        </button>
        <button
          data-gtm-trigger="add_to_favorites"
          :data-gtm-title="listing.title"
          @click.prevent="toggleGuestFavourite(stacking_context)"
          v-show="!liked"
          class="text-primary flex items-center"
        >
          <FaIcon :icon="['fal', 'heart']" class="text-gray-950 hover:text-primary" />
          <slot :liked="liked" :count="listing.favourites_count"></slot>
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import Http from "@/lib/Http"
export default {
  name: "Listing.Favourite",
  props: {
    listing: {
      type: Object,
      required: true,
    },
    guestFavourites: {
      type: [],
      required: false,
      default: [],
    },
  },
  data() {
    return {
      liked: false,
      stacking_contexts: ["top", "bottom"],
    }
  },
  mounted() {
    this.liked = this.signedIn ? this.listing.liked : this.guestLiked
  },
  methods: {
    async toggleGuestFavourite(stacking_context) {
      const method = this.liked ? "DELETE" : "POST"
      const url = this.liked
        ? `api/guest_favourites/${this.listing.id}.turbo_stream`
        : "api/guest_favourites.turbo_stream"

      const response = await Http({
        method,
        url,
        params: { id: this.listing.id, stacking_context },
        headers: { Accept: "text/vnd.turbo-stream.html" },
      })
      Turbo.renderStreamMessage(response.data)
      this.liked = !this.liked
    },
    toggleLike() {
      const liked = this.liked
      const { favourites_count } = this.listing

      this.liked = !liked
      if (this.liked) {
        this.listing.favourites_count = favourites_count + 1
      } else {
        this.listing.favourites_count = favourites_count - 1
      }

      Http({
        method: liked ? "DELETE" : "POST",
        url: "/api/listings/favourites",
        params: { listing_id: this.listing.id },
      })
        .then(() => {
          $.getScript("/listings/favourites/navbar")
          this.favouritesCount += liked ? -1 : 1
        })
        .catch((e) => {
          this.liked = liked
        })
    },
  },
  computed: {
    signedIn() {
      return window.config.userSignedIn
    },
    guestLiked() {
      const favourites = this.guestFavourites.map((item) => parseInt(item))
      return favourites.includes(this.listing.id)
    },
  },
  watch: {
    guestFavourites: {
      handler(newFavourites) {
        if (!this.signedIn) {
          this.liked = newFavourites.map((id) => parseInt(id)).includes(this.listing.id)
        }
      },
      immediate: true, // in case it’s already populated when mounted
    },
  },
}
</script>
